import secureLs from '@/libs/secureLs'
import secureCookies from '@/libs/cookies'

export default {
  data() {
    return {
      iframeUrl: `${process.env.VUE_APP_BASE_AUTH_MODULE || 'http://localhost:5173'}/reset-password${window.location.search}`,
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
    // Auto-logout user if they visit reset password with active session
    secureLs.clearItem()
    secureCookies.clearItem()
    localStorage.clear()
    sessionStorage.clear()
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      if (event.data && event.data.type === 'REDIRECT_LOGIN') {
        this.$router.push({ name: 'auth-login' })
      }
    },
  },
}
